import React from 'react';

const fmt = (v) => `${v?.quantity_per_unit ?? 0} ${v?.uom || 'EA'}${v?.scrap_factor_percent ? ` +${v.scrap_factor_percent}% scrap` : ''}`;

export const LineDiff = ({ diff, testId }) => {
  if (!diff) return null;
  const { added = [], removed = [], changed = [], unchanged_count = 0 } = diff;
  if (!added.length && !removed.length && !changed.length) {
    return <p className="text-xs text-slate-400 italic" data-testid={testId}>No line changes ({unchanged_count} unchanged)</p>;
  }
  return (
    <div className="space-y-1 text-xs font-mono" data-testid={testId}>
      {added.map(l => (
        <div key={`a-${l.component_sku}`} className="px-2 py-1 rounded bg-emerald-50 text-emerald-800 border border-emerald-100">+ {l.component_sku} · {fmt(l)}</div>
      ))}
      {removed.map(l => (
        <div key={`r-${l.component_sku}`} className="px-2 py-1 rounded bg-rose-50 text-rose-800 border border-rose-100 line-through decoration-rose-300">− {l.component_sku} · {fmt(l)}</div>
      ))}
      {changed.map(l => (
        <div key={`c-${l.component_sku}`} className="px-2 py-1 rounded bg-amber-50 text-amber-900 border border-amber-100">~ {l.component_sku} · {fmt(l.from)} → {fmt(l.to)}</div>
      ))}
      {unchanged_count > 0 && <p className="text-[10px] text-slate-400 font-sans">{unchanged_count} line{unchanged_count > 1 ? 's' : ''} unchanged</p>}
    </div>
  );
};
